// Feature flag keys used in LaunchDarkly.
// Expiry dates are noted and should be monitored to update or remove flags as needed.
// Use long date formats to avoid ambiguity.

// Release flags should be prefixed with "RELEASE_"

export const FEATURE_FLAGS = {
    RELEASE_ACTIVITY_PROCESSING_V2: 'of-cf-release-processing-state-v2-251105', // Recommended removal: 25th February 2026
    RELEASE_DATASHARING: 'of-cf-release-datasharing-260219', // Recommended removal: tba 2026
    RELEASE_DATASHARING_FILES_REVIEW: 'of-cf-release-datasharing-files-review-260427', // Recommended removal: July 2026
    RELEASE_GK_EVENTS: 'of-cf-release-goalkeeper-events-260309', // Recommended removal: May 2026
    RELEASE_FIXED_TIME_ANNOTATIONS: 'of-cf-release-fixed-time-annotations-260429', // Recommended removal: July 2026
    BATCH_SHARE_JOBS: 'of-cf-batch-share-jobs-datasharing-260219', // Recommended removal: tba 2026
    DATASHARING_DATE_RANGE_DAYS: 'of-cf-datasharing-date-range-260521', // Recommended removal: tba 2026
    RELEASE_IMPORT_HISTORY_BY_ACTIVITY: 'of-cf-release-import-history-by-activity-260609', // Recommended removal: tba 2026
    RELEASE_PERIOD_TEMPLATES: 'of-cf-release-period-templates-260604', // Recommended removal: tba 2026
    RELEASE_EDITOR_NEW_TABS: 'of-cf-release-new-editor-tabs',
} as const;
